import React, { useContext } from 'react';
import { ShopperContext } from '../context/shopper';
import HeadingBuilder from '../components/HeadingBuilder';
import YesOrNoQs from './YesOrNoQs'
import ShopperDeleteButLeadsCircle from './ShopperDeleteButLeadsCircle';
import * as Constants from '../constants';
import { useUtils } from "../hooks/useUtils";
import { usePhrasing } from "../hooks/useSkuUtils";
import { useParams, useNavigate } from 'react-router-dom';
import { ErrorList } from './ErrorList';
import { BackButton } from './BackButton';
import { useTranslation } from "react-i18next";

export const ShopperDeleteForm = () => {
    const { signedIn, shopper, circles, deleteShopper, signoutShopperPlus,
      errorsDoExist
    } = useContext(ShopperContext);
    console.log('sdf shopper: ', shopper)

    const navigate = useNavigate();

    const { shopper_is_leader_of_these_circles } = useUtils();
    const { getWithdrawTheQuestionTippyContent } = usePhrasing();

    const circlesShopperLeads =
      shopper_is_leader_of_these_circles({circles: circles, shopper_id: shopper.id});

    const circlesLeadWithShoppers =
      circlesShopperLeads.filter(c =>  c.shopper_count > 1);

    const {id} = useParams();
    console.log('sdf id: ', id)

    const { t } = useTranslation();
    
    async function removeShopper (e) {
      // TODO: is event (e) useful for anything?
  
      // Delete a shopper.
      // Backend enforces that the only one that can delete a shopper is the shopper.
  
      console.log("dsh before di", Date.now() );
      const rc = await deleteShopper(shopper.id);
      // If 'deleteShopper' throws an error, the intentional lack of a catch
      // causes termination at that point. It also terminates this 'removeShopper'
      // function and so avoids doing the 'signoutShopperPlus' function below.

      console.log("dsh rc", rc);
      console.log("dsh after dt", Date.now() );

      signoutShopperPlus( (x => {
          x = x || '/';
          return navigate(x);
        })
      );
    }

    // If length is 0 and we make the 'Singular' message, no big deal, won't use.
    const handleCirclesMessage =
      t('shopperDeleteForm.handleCirclesFirst.baseMessage') + (
        circlesLeadWithShoppers.length > 1
          ? t('shopperDeleteForm.handleCirclesFirst.circlesPlural')
          : t('shopperDeleteForm.handleCirclesFirst.circlesSingular')
      );

    // Before you go... You lead {{a_circle_that_has}} no other members.
    // To delete your account, you must first delete {{the_circle}}.
    const handleSoloCirclesMessage =
      circlesShopperLeads.length > 1
        ? t('shopperDeleteForm.handleCirclesFirst.circleWithoutShoppers', {
   a_circle_that_has: t('shopperDeleteForm.handleCirclesFirst.circlesThatHave'),
          the_circle: t('shopperDeleteForm.handleCirclesFirst.theCircles')
          })
        : t('shopperDeleteForm.handleCirclesFirst.circleWithoutShoppers', {
    a_circle_that_has: t('shopperDeleteForm.handleCirclesFirst.aCircleThatHas'),
           the_circle: t('shopperDeleteForm.handleCirclesFirst.theCircle')
          });

    const deleteButtonHeading =
    <>{t('shopperDeleteForm.areYouSure.buttonLabel')} '{shopper.identifier}'</>;

    if (signedIn) {
      return (
        <article>
          {/* TODO? <h3>Invite another Shopper to lead Circle "{circleObj.identifier}"</h3> */}

          <HeadingBuilder
            Size = 'h3'
            headingText = {t('shopper.deleteAccountButton.label')+':'}
            // Delete My Account: uiui
            value = {shopper.identifier}
          />

          <HeadingBuilder
            Size           = 'h1'
            headingText    = {t('global.areYouSure')}
            // Are You Sure?
            tippyAlertText = {t('shopperDeleteForm.areYouSure.tippyContent')}
            tippyText      = {Constants.DOT}
          />

          { circlesLeadWithShoppers.length > 0
          // If the Shopper leads Circle(s) and it has CircleShoppers...
            ? <ShopperDeleteButLeadsCircle
                messageReCircles = {handleCirclesMessage}
                circlesLead      = {circlesLeadWithShoppers}
              />
            : circlesShopperLeads.length > 0
            // If the Shopper leads Circle(s), then here because no Shoppers...
              ? <ShopperDeleteButLeadsCircle
                  messageReCircles = {handleSoloCirclesMessage}
                  circlesLead      = {circlesShopperLeads}
                />
              : <YesOrNoQs
                // Shopper leads no Circles, so way is clear to confirm Yes/No.
                  headingTextYes   = {deleteButtonHeading}
                  // Yes, delete Shopper 'uiui'
                  buttonActionYes  = {removeShopper}
            tippyAlertTextYes = {t('shopperDeleteForm.areYouSure.tippyContent')}
  
              headingTextNo = {t('shopperDeleteForm.areYouSure.buttonLabelNo')}
                  // No, don't delete Shopper
                  tippyAlertTextNo = {getWithdrawTheQuestionTippyContent({
                                       object_name: t('global.label.shopper')
                                     })}
                />
          }
          { errorsDoExist && <ErrorList /> }
          <br/>
          <BackButton />
        </article>
      )
    } else {
      return (
        <HeadingBuilder
          Size = 'h3'
          headingText = {t('global.notSignedInMessage')}
          // Not Authorized - Please Sign in or Sign up
        />
      )
    }
}

export default ShopperDeleteForm;